jQuery(document).ready(function ($) {

    /**
     * Click to reveal action
     */
    $( document ).on( 'click', '[data-affcoups-code-reveal]', function(e) {
        e.preventDefault();

        //console.log('Code Reveal');

        var couponId = $(this).data('affcoups-code-reveal');
        var currentUrl = new URL( window.location.href );
        var targetUrl = new URL( $(this).attr("href") );

        //console.log('couponId: ' + couponId);
        //console.log('currentUrl: ' + currentUrl.href);
        //console.log('targetUrl: ' + targetUrl.href);

        // Append coupon id to url
        var newTabUrl = currentUrl;
        newTabUrl.searchParams.set('affcoups_coupon', couponId);

        //console.log('targetUrl: ' + newTabUrl.href);

        window.open( newTabUrl.href );
        window.location.href = targetUrl.href;
    });

    /**
     * Get URL Parameter
     * @param name
     * @returns {*}
     */
    $.urlParam = function(name){
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results==null){
            return null;
        }
        else{
            return decodeURI(results[1]) || 0;
        }
    };

    var couponId = $.urlParam('affcoups_coupon');

    //console.log('couponId: ' + couponId);

    if ( couponId ) {

        setTimeout(function() {

            var couponModal = $('#affcoups-modal-coupon-' + couponId);

            if ( couponModal.length ) {
                $.magnificPopup.open({
                    items: {
                        src: couponModal
                    },
                    type: 'inline',
                    mainClass: 'affcoups',
                    callbacks: {
                        open: function() {
                            // Will fire when this exact popup is opened
                            // this - is Magnific Popup object

                            clipboard = new ClipboardJS('.affcoups-clipboard', {
                                container: document.getElementById('affcoups-modal-coupon-' + couponId),
                                text: function(trigger) {
                                    return trigger.getAttribute('data-clipboard-text');
                                }
                            });

                        },
                        close: function() {
                            // Will fire when popup is closed
                        }
                        // e.t.c.
                    }
                });
            }
        }, 1000);
    }

});


